

































import {
    Component,
    Vue,
    Prop
} from "vue-property-decorator";
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import JobApplication from "@/components/JobApplication.vue";
import TitleText from "../components/TitleText.vue";
import JobTitleInformation from "../components/JobTitleInformation.vue";
import axios from "axios";
import {
    API_URL
} from "../global";
import {
    pageDataType
} from "../types";
@Component({
    name: "jobformcomp",
    components: {
        JobApplication,
        JobTitleInformation
    }
})
export default class JobForm extends Vue {
    @Prop() pageData!: pageDataType;
    public data() {
        return {
            jobtitlelist: [],

        }
    }
    public created() {

        axios.get(`${API_URL}/others/settings/global-settings/`)
            .then(response => {
                (this as any).jobtitlelist = response.data
            })
            .catch(e => {
                (this as any).errors.push(e)
            })

    }
}
